import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { store } from '@/store';

// 評価者進捗
export class EvaluatorStudentProgress implements Serializable<EvaluatorStudentProgress> {
  evaluatorStudentID: number;
  studentNumber: string;
  schoolClass: SchoolClass;
  lastName: string;
  firstName: string;
  status: GEnum.StatusProgress; // 全体の進捗
  giftEvalProgress: GEnum.EvaluatorGiftProgress; // 他者評価進捗
  freeWordSkillProgress: GEnum.EvaluatorGiftProgress; // 強み評価進捗

  deserialize(input: any): EvaluatorStudentProgress {
    this.evaluatorStudentID = input.evaluatorStudentID;
    this.studentNumber = input.studentNumber;
    this.schoolClass = new SchoolClass().deserialize(input.schoolClass);
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.status = input.status;
    this.giftEvalProgress = input.giftEvalProgress;
    this.freeWordSkillProgress = input.freeWordSkillProgress;

    return this;
  }

  get fullName(): string {
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      return `${this.lastName} ${this.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      return `${this.firstName} ${this.lastName}`;
    }
  }

  get isStatusCompleted(): boolean {
    return this.status === GEnum.StatusProgress.Completed;
  }

  get isGiftProgressCompleted(): boolean {
    return this.giftEvalProgress === GEnum.EvaluatorGiftProgress.Completed;
  }

  get isFreeWordSkillProgressCompleted(): boolean {
    return this.freeWordSkillProgress === GEnum.EvaluatorGiftProgress.Completed;
  }
}
